import { useBrowserAPI } from "@/hooks/useBrowserAPI";
export const useTrackingQueryParams = () => {
    var _a, _b, _c, _d, _e;
    const { bWindow } = useBrowserAPI();
    const queryParam = new URLSearchParams(((_a = bWindow === null || bWindow === void 0 ? void 0 : bWindow.location) === null || _a === void 0 ? void 0 : _a.search) || "");
    const hash = (_c = (_b = bWindow === null || bWindow === void 0 ? void 0 : bWindow.location) === null || _b === void 0 ? void 0 : _b.hash) === null || _c === void 0 ? void 0 : _c.slice(1); // Remove the leading hash
    const hashParams = new URLSearchParams(hash || "");
    return {
        av_medium: (_d = queryParam.get("m")) !== null && _d !== void 0 ? _d : hashParams.get("m"),
        list_name: (_e = queryParam.get("ln")) !== null && _e !== void 0 ? _e : hashParams.get("ln"),
    };
};
